
jalaliObject = {
    g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
};

jalaliObject.jalaliToGregorian = function(j_y, j_m, j_d) {
    j_y = parseInt(j_y);
    j_m = parseInt(j_m);
    j_d = parseInt(j_d);
    var jy = j_y - 979;
    var jm = j_m - 1;
    var jd = j_d - 1;

    var j_day_no = 365 * jy + parseInt(jy / 33) * 8 + parseInt((jy % 33 + 3) / 4);
    for (var i = 0; i < jm; ++i) j_day_no += jalaliObject.j_days_in_month[i];

    j_day_no += jd;

    var g_day_no = j_day_no + 79;

    var gy = 1600 + 400 * parseInt(g_day_no / 146097); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
    g_day_no = g_day_no % 146097;

    var leap = true;
    if (g_day_no >= 36525) /* 36525 = 365*100 + 100/4 */
    {
        g_day_no--;
        gy += 100 * parseInt(g_day_no / 36524); /* 36524 = 365*100 + 100/4 - 100/100 */
        g_day_no = g_day_no % 36524;

        if (g_day_no >= 365) g_day_no++;
        else leap = false;
    }

    gy += 4 * parseInt(g_day_no / 1461); /* 1461 = 365*4 + 4/4 */
    g_day_no %= 1461;

    if (g_day_no >= 366) {
        leap = false;

        g_day_no--;
        gy += parseInt(g_day_no / 365);
        g_day_no = g_day_no % 365;
    }

    for (var i = 0; g_day_no >= jalaliObject.g_days_in_month[i] + (i == 1 && leap); i++)
        g_day_no -= jalaliObject.g_days_in_month[i] + (i == 1 && leap);
    var gm = i + 1;
    var gd = g_day_no + 1;

    gm = gm < 10 ? "0" + gm : gm;
    gd = gd < 10 ? "0" + gd : gd;

    return [gy, gm, gd];
}

function jalaliToGreg(jDate,delimiter){
    if(typeof delimiter === 'undefided'){
        delimiter = '-';
    }
    dateSplitted = jDate.split(delimiter)
    gD = jalaliObject.jalaliToGregorian(dateSplitted[0], dateSplitted[1], dateSplitted[2]);
    gResult = gD[0] + "-" + gD[1] + "-" + gD[2];
    // console.log(gResult);
    return gResult;
}
$(document).ready(function () {

    if ($(window).width() > 768) {
        var numberOfMonthsResponsive = 2;
    } else {
        var numberOfMonthsResponsive = 1;
    }

    if (age == undefined){var age = 18;}

    //for dept and return reservations
    $('.deptCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        maxDate:'+360d',
        showButtonPanel: true,
        onSelect: function(dateText){
            $(".returnCalendar").datepicker('option', 'minDate', dateText);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });
    $('.returnCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.deptCalendar').val(),
        maxDate:'+360d',
        showButtonPanel: true,
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });


    //for just shamsi dept and return reservations
    $('.shamsiDeptCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function(dateText){
            $(".shamsiReturnCalendar").datepicker('option', 'minDate', dateText);
            let regds_dept_date_local = $("#regds_dept_date_local").is(":disabled")
            if(regds_dept_date_local){
                $('.cbox-count-nafar').toggle();
                $('.down-count-nafar').parents().find('.down-count-nafar').toggleClass('fa-caret-up');
            }else {
                setTimeout(function(){
                    $('#regds_dept_date_local').trigger('click').focus()
                },500)

            }
        },
    });
    $('.shamsiReturnCalendar').datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendar').val(),
        showButtonPanel: !0,
    });


    //for just shamsi dept and return hotel reservations
    $('.shamsiDeptCalendarForHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".shamsiReturnCalendarForHotel").datepicker('option', 'minDate', dateText);
        }
    });

    $('.deptCalendarForExternalHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".returnCalendarForExternalHotel").datepicker('option', 'minDate', dateText);
        }
    });


    /*Added by Qorbani */
    var datepickerDiv = $('#ui-datepicker-div');
    var selectedStartDate = '+1d';
    var hotelStartDateShamsi =  $('.hotelStartDateShamsi');
    var hotelEndDateShamsi = $('.hotelEndDateShamsi');
    hotelStartDateShamsi.datepicker({
        numberOfMonths:numberOfMonthsResponsive,
        minDate:'Y/M/D',
        showButtonPanel: !0,
        onSelect:function(dateText){
            var dt = $(this).datepicker('getDate');
            dt.setDate(dt.getDate() + 1);
            hotelEndDateShamsi.datepicker('option','minDate',dt);
            selectedStartDate = dt;

        },
        beforeShow : function (n) {
            e(n,!0);
            datepickerDiv.addClass('INH_class_Datepicker');
        }
    });
    hotelEndDateShamsi.datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate : selectedStartDate,
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {
            var startDateGreg = convertJalaliToGregorian(hotelStartDateShamsi.val(),hotelStartDateShamsi);
            var endDateGreg = convertJalaliToGregorian(dateTextReturn,hotelStartDateShamsi);
           
            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);


            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);
         
            var dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForHotelLocal').html(endDateGreg);
            $('#NightsForHotelLocal').val(endDateGreg);
            $('#stayingTimeForHotelLocal').val(' مدت اقامت '+ endDateGreg + ' شب ');

        },
        beforeShow: function(n) {
            e(n,!0);
            datepickerDiv.addClass('INH_class_Datepicker');
        }
    });
    /*this is for external Hotel */
    var externalHotelStartDateShamsi =  $('.externalHotelStartDateShamsi');
    var externalHotelEndDateShamsi = $('.externalHotelEndDateShamsi');
    // var datepickerDiv = $('#ui-datepicker-div');
    var externalSelectedStartDate = '+1d';
    externalHotelStartDateShamsi.datepicker({
        numberOfMonths:numberOfMonthsResponsive,
        minDate:'Y/M/D',
        showButtonPanel: !0,
        onSelect:function(dateText){
            var dt = $(this).datepicker('getDate');
            dt.setDate(dt.getDate() + 1);
            externalHotelEndDateShamsi.datepicker('option','minDate',dt);
            externalSelectedStartDate = dt;

        },
        beforeShow : function (n) {
            e(n,!0);
            datepickerDiv.addClass('INH_class_Datepicker');
        }
    });
    externalHotelEndDateShamsi.datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate : externalSelectedStartDate,
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorianexternal(externalHotelStartDateShamsi.val(),externalHotelStartDateShamsi);
            var endDateGreg = convertJalaliToGregorianexternal(dateTextReturn,externalHotelStartDateShamsi);

            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            var dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForExternalHotelLocal').html(endDateGreg);
            $('#NightsForExternalHotelLocal').attr("value", endDateGreg);
            $('#stayingTimeForExternalHotelLocal').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');

        },
        beforeShow: function(n) {
            e(n,!0);
            datepickerDiv.addClass('INH_class_Datepicker');
        }
    });
    /*End Edited By Qorbani*/

    $('.shamsiDeptCalendarForVilla').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".shamsiReturnCalendarForVilla").datepicker('option', 'minDate', dateText);
        }
    });
    $('.shamsiDeptCalendarForPackage').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".shamsiReturnCalendarForPackage").datepicker('option', 'minDate', dateText);
        }
    });
    $('.shamsiDeptCalendarForEghamat').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".shamsiReturnCalendarForEghamat").datepicker('option', 'minDate', dateText);
        }
    });

    $('.shamsiReturnCalendarForHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendarForHotel').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorian($('.shamsiDeptCalendarForHotel').val());
            var endDateGreg = convertJalaliToGregorian(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForHotelLocal').html(endDateGreg);
            $('#NightsForHotelLocal').attr("value", endDateGreg);
            $('#stayingTimeForHotelLocal').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');
        }
    });

    $('.returnCalendarForExternalHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.deptCalendarForExternalHotel').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorianexternal($('.shamsiDeptCalendarForHotel').val());
            var endDateGreg = convertJalaliToGregorianexternal(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForExternalHotelLocal').html(endDateGreg);
            $('#NightsForExternalHotelLocal').attr("value", endDateGreg);
            $('#stayingTimeForExternalHotelLocal').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');
        }
    });

    $('.shamsiReturnCalendarForVilla').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendarForVilla').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorianVilla($('.shamsiDeptCalendarForVilla').val());
            var endDateGreg = convertJalaliToGregorianVilla(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForVillaLocal').html(endDateGreg);
            $('#NightsForVillaLocal').attr("value", endDateGreg);
            $('#stayingTimeForVillaLocal').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');
        }
    });

    $('.shamsiReturnCalendarForPackage').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendarForPackage').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {
            var startDateGreg = convertJalaliToGregorianPackage($('.shamsiDeptCalendarForPackage').val());
            var endDateGreg = convertJalaliToGregorianPackage(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForPackage').html(endDateGreg);
            $('#NightsForPackage').attr("value", endDateGreg);
            $('#stayingTimeForPackage').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');
        }
    });
    $('.shamsiReturnCalendarForEghamat').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.shamsiDeptCalendarForEghamat').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorianEghamat($('.shamsiDeptCalendarForEghamat').val());
            var endDateGreg = convertJalaliToGregorianEghamat(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);

            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForEghamatLocal').html(endDateGreg);
            $('#NightsForEghamatLocal').attr("value", endDateGreg);
            $('#stayingTimeForEghamatLocal').attr("value",' مدت اقامت '+ endDateGreg + ' شب ');
        }
    });

    //for shamsi and gregorian dept and return hotel reservations
    $('.deptCalendarForHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function (dateText) {
            $(".returnCalendarForHotel").datepicker('option', 'minDate', dateText);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker")
        }
    });
    $('.returnCalendarForHotel').
    datepicker({
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.deptCalendarForHotel').val(),
        showButtonPanel: !0,
        onSelect: function (dateTextReturn) {

            var startDateGreg = convertJalaliToGregorian($('.deptCalendarForHotel').val());
            var endDateGreg = convertJalaliToGregorian(dateTextReturn);


            var startDate = new Date(startDateGreg);
            var endDate = new Date(endDateGreg);


            var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
            var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

            dayDiff = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

            $('#stayingTimeForExternalHotelLocal').html(endDateGreg);
            $('#NightsForExternalHotelLocal').attr("value", endDateGreg);
        },
        beforeShow: function(n) {
            e(n, !0);
            $("#ui-datepicker-div").addClass("INH_class_Datepicker");
        }
    });


    //for just gregorian dept and return reservations
    $('.gregorianDeptCalendar').datepicker({
        regional: '',
        numberOfMonths: numberOfMonthsResponsive,
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        onSelect: function(dateText){
            $(".gregorianReturnCalendar").datepicker('option', 'minDate', dateText);
        },
    });
    $('.gregorianReturnCalendar').datepicker({
        regional: '',
        numberOfMonths: numberOfMonthsResponsive,
        minDate: $('.gregorianDeptCalendar').val(),
        showButtonPanel: !0,
    });


    //for shamsi birthday
    $('body').delegate('.shamsiBirthdayCalendar','focus', function(e) {
        $(this).datepicker({
            maxDate: 'Y/M/D',
            showButtonPanel: !0,
            changeMonth: true,
            changeYear: true,
            yearRange: '1300:1480'
        });
    });


    //for adults shamsi birthday
    $('.shamsiAdultBirthdayCalendar').datepicker({
        maxDate: '-12Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for childs shamsi birthday
    $('.shamsiChildBirthdayCalendar').datepicker({
        minDate: '-12Y',
        maxDate: '-2Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for infants shamsi birthday
    $('.shamsiInfantBirthdayCalendar').datepicker({
        minDate: '-2Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for -12 shamsi birthday
    $('.shamsiUnder12BirthdayCalendar').datepicker({
        minDate: '-12Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian birthday
    $('.gregorianBirthdayCalendar').datepicker({
        regional: '',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for adults gregorian birthday
    $('.gregorianAdultBirthdayCalendar').datepicker({
        regional: '',
        maxDate: '-12Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for childs gregorian birthday
    $('.gregorianChildBirthdayCalendar').datepicker({
        regional: '',
        minDate: '-12Y',
        maxDate: '-2Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for infants gregorian birthday
    $('.gregorianInfantBirthdayCalendar').datepicker({
        regional: '',
        minDate: '-2Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for -12 gregorian birthday
    $('.gregorianUnder12BirthdayCalendar').datepicker({
        regional: '',
        minDate: '-12Y',
        maxDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for driver (min age To Rent) shamsi birthday
    $('.shamsiDriverBirthdayCalendar').datepicker({
        maxDate: '-' + age + 'Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for driver (min age To Rent) gregorian birthday
    $('.gregorianDriverBirthdayCalendar').datepicker({
        regional: '',
        maxDate: '-' + age + 'Y',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi with no limit
    $('.shamsiNoLimitCalendar').datepicker({
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian with no limit
    $('.gregorianNoLimitCalendar').datepicker({
        regional: '',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi from today
    $('.shamsiFromTodayCalendar').datepicker({
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480'
    });


    //for gregorian from today
    $('.gregorianFromTodayCalendar').datepicker({
        regional: '',
        minDate: 'Y/M/D',
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1920:2120'
    });


    //for shamsi range one month
    $('.shamsiRangeFirstCalendar').datepicker({
        showButtonPanel: !0,
        changeMonth: true,
        changeYear: true,
        yearRange: '1300:1480',
        onSelect: function (dateText) {

            var newDate = new Date(dateText);
            newDate.setDate(newDate.getDate() + 31);
            if (newDate.getMonth() == 10) {
                var dd = newDate.getDate();
                var mm = newDate.getMonth() - 9;
                var y = newDate.getFullYear() + 1;
            } else {
                var dd = newDate.getDate();
                var mm = newDate.getMonth() + 1;
                var y = newDate.getFullYear();
            }
            var formattedDate = y + '-' + mm + '-' + dd;

            $('.shamsiRangeSecondCalendar').datepicker({
                minDate: dateText,
                maxDate: formattedDate,
                changeMonth: true,
                changeYear: true,
                yearRange: '1300:1480'
            });
        }
    });

});

function convertJalaliToGregorian(jDate,elem) {
    var date1 = elem.val();
    var date2 = jDate;
    // var jqXHR1 = date1
    // var jqXHR2 = date2
    // var res1 = jqXHR1.replaceAll("-", "/");
    // var res2 = jqXHR2.replaceAll("-", "/");
    // var startDate = new Date(res1);
    // var endDate = new Date(res2);
    var res1 = jalaliToGreg(date1,'-');
    var res2 = jalaliToGreg(date2,'-');
    var startDate = new Date(res1);
    var endDate = new Date(res2);

    var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
    var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);

    var diffTime = Math.abs(endDate - startDate);
    var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    var result = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

    return result;

}
function convertJalaliToGregorianexternal(jDate,elem) {
    var date1 = elem.val()
    var date2 = jDate
    // var jqXHR1 = date1
    // var jqXHR2 = date2
    // var res1 = jqXHR1.replaceAll("-", "/");
    // var res2 = jqXHR2.replaceAll("-", "/");
    var res1 = jalaliToGreg(date1,'-');
    var res2 = jalaliToGreg(date2,'-');
    var startDate = new Date(res1);
    var endDate = new Date(res2);

    var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
    var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);
    var result = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

    return result;

}
function convertJalaliToGregorianEghamat(jDate) {
    var date1 = $(".shamsiDeptCalendarForEghamat").val()
    var date2 = jDate
    // var jqXHR1 = date1
    // var jqXHR2 = date2
    // var res1 = jqXHR1.replaceAll("-", "/");
    // var res2 = jqXHR2.replaceAll("-", "/");
    var res1 = jalaliToGreg(date1,'-');
    var res2 = jalaliToGreg(date2,'-');
    var startDate = new Date(res1);
    var endDate = new Date(res2);

    var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
    var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);
    var result = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

    return result;


}
function convertJalaliToGregorianVilla(jDate) {
    var date1 = $(".shamsiDeptCalendarForVilla").val()
    var date2 = jDate
    // var jqXHR1 = date1
    // var jqXHR2 = date2
    // var res1 = jqXHR1.replaceAll("-", "/");
    // var res2 = jqXHR2.replaceAll("-", "/");
    var res1 = jalaliToGreg(date1,'-');
    var res2 = jalaliToGreg(date2,'-');
    var startDate = new Date(res1);
    var endDate = new Date(res2);

    var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
    var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);
    var result = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

    return result;

}
function convertJalaliToGregorianPackage(jDate) {
    var date1 = $(".shamsiDeptCalendarForPackage").val()
    var date2 = jDate
    // var jqXHR1 = date1
    // var jqXHR2 = date2
    // var res1 = jqXHR1.replaceAll("-", "/");
    // var res2 = jqXHR2.replaceAll("-", "/");
    var res1 = jalaliToGreg(date1,'-');
    var res2 = jalaliToGreg(date2,'-');
    var startDate = new Date(res1);
    var endDate = new Date(res2);

    var fullDaysSinceEpochStart = Math.floor(startDate/8.64e7);
    var fullDaysSinceEpochEnd = Math.floor(endDate/8.64e7);
    var result = fullDaysSinceEpochEnd - fullDaysSinceEpochStart;

    return result;

}





// $('body').on('click' , '.deptCalendar22', function (e) {
//     e.each(function (b){
//         b.datepicker({
//             numberOfMonths: numberOfMonthsResponsive,
//             minDate: 'Y/M/D',
//             maxDate:'+360d',
//             showButtonPanel: true,
//             onSelect: function(dateText){
//                 $(".returnCalendar").datepicker('option', 'minDate', dateText);
//             },
//             beforeShow: function(n) {
//                 e(n, !0);
//                 $("#ui-datepicker-div").addClass("INH_class_Datepicker")
//             }
//         });
//     })
// })



